<template>
  <div>
    <PageHeader :title="nameTitle" :items="headerItems" />
    <div style="border-radius: 5px; background-color: white; padding: 20px">
      <div class="section" :key="mainKey">
        <b-row class="mb-3">
          <b-col cols="12">
            <BaseText @input="formData.title = $event" title="عنوان دعوت" placeholder="عنوان دعوت" required :showError="errors.titleError" :errortext="errors.text" />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <DateTimeOffset @input="expireDate = $event" :value="expireDate" title="تاریخ انقضا" placeholder="تاریخ انقضا" required />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <ComboBox
              @selectedItem="selectCoin($event)"
              :selectedValue="selectedCoin"
              title="ارز"
              placeholder="ارز"
              :searchedData="searchedCoins"
              @searchedItem="searchCoin($event)"
            />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <BaseText inputType="number" :maxlength="10" @input="formData.amount = $event" title="مقدار ارز" placeholder="مقدار ارز" />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <FormTags isAddUser @tagListUpdate="tagListUpdate($event)" :tags="FormTagData.tags" title="بانک اطلاعاتی" tagsLength="50" maxlength="50" />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <TextAreaInput @input="formData.smsText = $event" title="متن پیامک" placeholder="متن پیامک" required :showError="errors.smsError" :errortext="errors.text" />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <TextAreaInput
              @input="formData.greetingText = $event"
              title="متن خوش‌آمد گویی"
              placeholder="متن خوش‌آمد گویی"
              required
              :showError="errors.greetingError"
              :errortext="errors.text"
            />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <UploadBox title="اکسل کاربران" @fileBoxData="uploadedFiles($event)" />
          </b-col>
        </b-row>
      </div>
      <div>
        <div class="buttonClass">
          <Button @click.native="submit" btnClass="submitButton" text="ثبت" :loading="disableSubmit" />
          <b-button @click="$bvModal.show('cancleModal')" class="cancleButton">
            <span class="cancleTitle">انصراف</span>
          </b-button>
          <b-modal id="cancleModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
            <div class="error-wrapper">
              <div class="mb-4">
                <img src="@/assets/images/checked1.svg" />
              </div>
              <div class="error-title">آیا از انصراف خود مطمئن هستید؟</div>
              <div class="buttons">
                <div @click="$bvModal.hide('cancleModal')">
                  <button class="cancelButton">خیر</button>
                </div>
                <div @click="goBack()">
                  <button class="approveButton">بلی</button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
        <Toast title="اطلاعات با موفقیت ذخیره شد" :showToast="submitAlert" />
      </div>
      <NotifModal @isClose="closedModal" :showNotif="NotifModal" :description="NotifDesc" :key="NotifModalKey" />
      <ErrorModal v-if="this.errors.filesError" :key="ErrorModalKey" />
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import FormTags from '@/components/common/form/formModules/FormTags.vue'
import UploadBox from '@/components/common/form/formModules/UploadBox.vue'
import Toast from '../../common/Toast.vue'
import Button from '../../common/Button.vue'
import NotifModal from './Modal.vue'
import walletDataProvider from '../../../services/wallet'
import ErrorModal from './ErrorModal.vue'
import notificationsDataProvider from '../../../services/notifications'
import moment from 'jalali-moment'

export default {
  name: 'invitation-setting',
  components: {
    PageHeader,
    BaseText,
    TextAreaInput,
    ComboBox,
    Toast,
    Button,
    FormTags,
    UploadBox,
    NotifModal,
    ErrorModal,
    DateTimeOffset,
  },

  data() {
    return {
      forceUpdateFlag: true,
      disableSubmit: false,
      submitAlert: false,
      searchedCoins: [],
      selectedCoin: '',
      AllCoins: [],
      formData: {
        title: '',
        amount: 0,
        smsText: '',
        greetingText: '',
        tag: [],
        files: [],
      },
      FormTagData: {
        newTagPlaceholder: 'اضافه کردن تگ',
        tags: [],

        newTag: '',
      },
      NotifModal: false,
      ErrorModalKey: 2,
      NotifModalKey: 1,
      mainKey: 0,
      NotifDesc: '',
      errors: {
        greetingError: false,
        smsError: false,
        titleError: false,
        filesError: false,
        text: 'پر کردن فیلد زیر الزامیست',
      },
      validated: false,
      expireDate: () => {
        new Date()
      },
    }
  },
  computed: {
    nameTitle() {
      return 'دعوت کاربران'
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: this.nameTitle,
          active: true,
        },
      ]
    },
  },
  methods: {
    clearErrors() {
      this.errors.titleError = false
      this.errors.smsError = false
      this.errors.greetingError = false
      this.errors.filesError = false
    },
    validation() {
      this.validated = false
      this.clearErrors()
      if (this.formData.title.length == 0) {
        this.errors.titleError = true
      }
      if (this.formData.smsText == 0) {
        this.errors.smsError = true
      }
      if (this.formData.greetingText.length == 0) {
        this.errors.greetingError = true
      }
      if (this.formData.files.length == 0) {
        this.errors.filesError = true
        this.ErrorModalKey += 1
        return false
      }
      if (!this.errors.titleError && !this.errors.smsError && !this.errors.greetingError && !this.errors.filesError) {
        this.validated = true
      }
    },
    closedModal() {
      this.clearForm()
      this.$router.push({ path: '/list/invitaion' })
    },
    clearForm() {
      this.forceUpdateFlag = true
      this.disableSubmit = false
      this.submitAlert = false
      this.searchedCoins = []
      this.selectedCoin = ''
      this.AllCoins = []
      this.formData = {
        title: '',
        amount: 0,
        smsText: '',
        greetingText: '',
        tag: [],
        files: [],
      }
      this.FormTagData = {
        newTagPlaceholder: 'اضافه کردن تگ',
        tags: [],
        newTag: '',
      }
      this.mainKey += 1
    },
    submit() {
      this.disableSubmit = true
      this.validation()
      if (this.validated) {
        let temp = {
          title: this.formData.title,
          coinName: this.selectedCoin,
          coinAmount: Number(this.formData.amount),
          fromDb: this.formData.tag.map((t) => t.title),
          smsText: this.formData.smsText,
          greetingText: this.formData.greetingText,
          files: this.formData.files,
          expireDate: moment(this.expireDate).format(),
        }
        notificationsDataProvider
          .addNewInvitaion(temp)
          .then((res) => {
            this.showSuccessModal(res.data.data.response)
          })
          .catch((err) => {
            this.showSuccessModal(err.response.data.message)
          })
      } else {
        this.disableSubmit = false
      }
    },
    showSuccessModal(payload) {
      this.NotifDesc = payload
      this.NotifModal = true
      this.NotifModalKey += 1
      this.disableSubmit = false
    },
    uploadedFiles($event) {
      this.formData.files = $event.map((e) => e.url)
    },
    tagListUpdate(payload) {
      for (let i = 0; i < payload.length; i++) {
        this.formData.tag.push({ title: payload[i] })
        this.FormTagData.tags.push({ title: payload[i] })
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    selectCoin(payload) {
      this.searchedCoins = []
      this.searchedCoins.push(payload)
      this.selectedCoin = payload.key
    },
    searchCoin(payload) {
      if (payload !== '') {
        this.searchedCoins = []
        for (var i = 0; i < this.AllCoins.length; i++) {
          if (this.AllCoins[i].value.indexOf(payload.toUpperCase()) != -1) {
            this.searchedCoins.push(this.AllCoins[i])
          }
        }
      } else {
        this.searchedCoins = this.AllCoins
      }
    },
  },
  beforeMount() {
    this.forceUpdateFlag = false
  },
  mounted() {
    walletDataProvider
      .getCoinList()
      .then((res) => {
        this.AllCoins = res.data.data
      })
      .then(() => {
        for (let i = 0; i < this.AllCoins.length; i++) {
          this.AllCoins[i].value = this.AllCoins[i]['from']
          this.AllCoins[i].key = this.AllCoins[i]['from']
          delete this.AllCoins[i].from
          delete this.AllCoins[i].from
        }
      })
      .then(() => {
        this.searchedCoins = this.AllCoins
      })
  },
}
</script>

<style scoped lang="sass">
@import 'index'
</style>
